import { createSlice } from '@reduxjs/toolkit';

import {
    sendEmailVerificationCode,
    submitEmailVerificationCode,
} from '@/redux/modules/account/createAccountEmailVerification/createAccountEmailVerification.actions';
import { defaultCreateAccountEmailVerificationSlice } from '@/redux/modules/account/createAccountEmailVerification/createAccountEmailVerification.types';

import { clearSignupErrors } from '../createAccount/clearSignupErrors.action';
import { submitCreateAccount } from '../createAccount/createAccount.actions';

const createAccountEmailVerificationSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(sendEmailVerificationCode.pending, (slice) => {
            slice.sendOtp.error = null;
            slice.sendOtp.submitted = true;
            slice.sendOtp.success = false;
            slice.verifyOtp.error = null;
            slice.verifyOtp.submitted = false;
            slice.verifyOtp.success = false;
        });
        builder.addCase(sendEmailVerificationCode.fulfilled, (slice, { payload }) => {
            slice.unregisteredUserId = payload.unregisteredUserId;
            slice.sendOtp.error = null;
            slice.sendOtp.submitted = false;
            slice.sendOtp.success = true;
            slice.resendCooldown.completionTime = payload.cooldownCompletionTime;
        });
        builder.addCase(sendEmailVerificationCode.rejected, (slice, { payload }) => {
            slice.sendOtp.error = payload;
            slice.sendOtp.submitted = false;
            slice.sendOtp.success = false;
        });
        builder.addCase(submitEmailVerificationCode.pending, (slice) => {
            slice.verifyOtp.error = null;
            slice.verifyOtp.submitted = true;
            slice.verifyOtp.success = false;
        });
        builder.addCase(submitEmailVerificationCode.fulfilled, (slice) => {
            slice.verifyOtp.error = null;
            slice.verifyOtp.submitted = false;
            slice.verifyOtp.success = true;
        });
        builder.addCase(submitEmailVerificationCode.rejected, (slice, { payload }) => {
            slice.verifyOtp.error = payload;
            slice.verifyOtp.submitted = false;
            slice.verifyOtp.success = false;
        });

        builder.addCase(submitCreateAccount.fulfilled, () => defaultCreateAccountEmailVerificationSlice);

        builder.addCase(clearSignupErrors, (slice) => {
            slice.sendOtp.error = null;
            slice.verifyOtp.error = null;
        });
    },
    initialState: defaultCreateAccountEmailVerificationSlice,
    name: 'createAccountEmailVerification',
    reducers: {
        clearResendCooldown: (slice) => {
            slice.resendCooldown.completionTime = null;
        },
    },
});

export const { clearResendCooldown } = createAccountEmailVerificationSlice.actions;
export const { reducer: createAccountEmailVerificationReducer } = createAccountEmailVerificationSlice;
